import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import logo from '../../../images/logoaccess.png';
import '../../../css/financeiro-parcela-pagar.css';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getIdiomaCodigo, getText } from '../../../util/translations';
import { getAuthToken } from '../../../util/authSession';
import Processando from '../../../components/Processando';

const logoStyle = {
  maxWidth: '100%',
  maxHeight: '48px',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
};

export default function CadastroEventoParticipanteConviteConcluido({ match }) {
  const id = match.params.id;
  const token = getAuthToken();
  const [evento, setEvento] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  // Pega o idioma do state ou da URL, ou usa 'portugues' como padrão
  const idioma = getIdiomaCodigo() || new URLSearchParams(window.location.search).get('idioma') || 'portugues';

  const buscar = () => {
    setIsLoading(true);
    setIsError(false);
    api({
      method: "get",
      action: '/eventoSemLogin/' + id,
    }).then(response => {
      var dadosEvento = response.data.data;
      setEvento(dadosEvento);
      setIsLoading(false);
    }).catch(err => {
      setIsLoading(false);
      setIsError(true);
      toast.error(getText('error') + getText('errorRefreshPage'));
    });
  };//buscar

  /*
  const salvar = () => {
    api({
      method: 'put',
      action: '/participante/concluirConfirmacaoDados/' + id,
      token: token,
    })
      .then(function (response) {
      })
      .catch(function (error) {
        //alert(error)
      });
  }; //salvar
  */

  useEffect(() => { //onload
    buscar();
    //salvar();
  },
    // eslint-disable-next-line
    []);

  return (
    <div
      className="fin-pp"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'none',
        backgroundColor: evento?.cor ?? '#AAAAAA',
      }}
    >
      {isLoading && <Processando idioma={idioma} />}
      <div style={{ width: '100%', maxWidth: 480, padding: '0 16px' }}>
        <div className="fin-pp__card" style={{ padding: 32 }}>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            {localStorage.getItem('logomarcaEvento') ?
              <img alt="" src={localStorage.getItem('logomarcaEvento')} style={logoStyle} className='mb-4' /> :
              <img alt="" src={logo} style={logoStyle} className='mb-4' />
            }
          </div>
          {evento &&
            <p style={{ textAlign: 'center', color: 'var(--fin-tx)' }}>
              {getText('presenceConfirmed')} <strong>{evento?.nome ?? ""}</strong>, {getText('moreDetailsSoon')}<br />
              {getText('contactInfo')}
            </p>
          }
          {id !== '990983771759499923' && (
            <p style={{ textAlign: 'center', color: 'var(--fin-mt)' }}>
              {getText('accessGroup')}<br />
              {getText('phone')}
            </p>
          )}
          {((evento?.linkfinalcadastro ?? "") !== '') ?
            <>
              <p style={{ textAlign: 'center', color: 'var(--fin-mt)', marginTop: 12 }}>{getText('clickBelowAccess')}</p>
              <div style={{ textAlign: 'center', marginTop: 8 }}>
                <a
                  href={evento?.linkfinalcadastro}
                  target="_blank"
                  rel="noreferrer"
                  className="fin-pp__btn fin-pp__btn--primary"
                >
                  <FaExternalLinkAlt size={16} style={{ marginRight: 6 }} />
                  {getText('accessContent')}
                </a>
              </div>
            </>
            : null
          }
        </div>
      </div>
    </div>
  );
}
